export default function B2BAdvantages() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-building-line mr-2"></i>
            Partenaire des Professionnels
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Pourquoi les Syndics & Agences nous choisissent
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Déjà partenaire de nombreuses agences immobilières à Bruxelles et en Wallonie
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Réactivité */}
          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
              <i className="ri-time-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Intervention sous 48h</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Réactivité garantie pour vos urgences. Diagnostic vidéo en 2h, intervention sur site sous 48h maximum.
            </p>
          </div>

          {/* Sérieux */}
          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
              <i className="ri-shield-check-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Pièces d'origine certifiées</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Uniquement des pièces Winkhaus, Roto, MACO d'origine. Garantie 2 ans sur toutes nos interventions.
            </p>
          </div>

          {/* Facilité */}
          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
              <i className="ri-smartphone-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Gain de temps majeur</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Diagnostic vidéo WhatsApp : plus besoin de déplacement pour un premier avis. Économisez du temps et de l'argent.
            </p>
          </div>

          {/* Preuve Sociale */}
          <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100">
            <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
              <i className="ri-team-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">150+ Clients B2B</h3>
            <p className="text-gray-600 text-sm leading-relaxed">
              Syndics, agences immobilières et copropriétés nous font confiance pour la gestion de leurs parcs immobiliers.
            </p>
          </div>
        </div>

        {/* Section Image Technique - REMOVED */}
      </div>
    </section>
  );
}